var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgXBig = function SvgXBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ED1D1D",
    cx: 75,
    cy: 75,
    r: 75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.396 48c.405 0 .821.161 1.13.461.632.61.632 1.59 0 2.202L77.88 75.5l25.648 24.84c.63.61.63 1.59 0 2.2a1.637 1.637 0 0 1-2.273 0L75.5 77.602l-25.754 24.94a1.637 1.637 0 0 1-2.273 0c-.63-.61-.63-1.59 0-2.2L73.121 75.5 47.473 50.663a1.519 1.519 0 0 1 0-2.202c.31-.3.726-.461 1.13-.461.405 0 .822.15 1.131.461L75.5 73.413l25.766-24.952c.27-.272.623-.421.978-.454z",
    stroke: "#FFF",
    strokeWidth: 5,
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgXBig;